import { render, staticRenderFns } from "./CounselorEthnicitySelect.vue?vue&type=template&id=d1f90762&"
import script from "./CounselorEthnicitySelect.vue?vue&type=script&lang=js&"
export * from "./CounselorEthnicitySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports